import { Box, Button, Heading, Text, Image, Input, useToast } from '@chakra-ui/react';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import './App.css';

export const DownloadMedia = ({ setSide, side }) => {
  const [mediaUrl, setMediaUrl] = useState('');
  const [pre, setPre] = useState('');
  const navigate = useNavigate()
  const toast = useToast()


  const handleDownload = async () => {
    if (!mediaUrl) {
      toast({ title: 'Check the URL', description: 'Please enter a valid URL', status: 'error', duration: 2000, isClosable: true, position: 'top' })
      return;
    }

    try {
      const response = await fetch(mediaUrl);
      if (!response.ok) {
        toast({ title: 'Check the URL', description: 'Network response was not Ok!!', status: 'error', duration: 2000, isClosable: true, position: 'top' })
        throw new Error('Network response was not ok');
      }

      const contentDisposition = response.headers.get('content-disposition');
      const contentType = response.headers.get('content-type');
      const filenameFromHeader = contentDisposition?.split('filename=')[1] || '';
      const extensionFromHeader = filenameFromHeader.split('.').pop();
      const extensionFromContentType = contentType?.split('/').pop();

      const extension = extensionFromHeader || extensionFromContentType || 'unknown';
      const filename = `downloaded_media.${extension}`;

      const blob = await response.blob();

      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);

      toast({ title: 'Media Downloader', description: 'File downloaded', status: 'success', duration: 2000, isClosable: true, position: 'top' })
      setPre(mediaUrl)
      setMediaUrl('')
    } catch (error) {
      toast({ title: 'Check the URL', status: 'error', duration: 2000, isClosable: true, position: 'top' })
    }
  };

  return (
    <Box>
      {!side && <Box display={'flex'} alignItems={'center'} fontSize={'25px'} fontWeight={'bold'} m={'0.5cm auto 0.5cm auto'}>
        <Text ml={'10px'} cursor={'pointer'} onClick={() => setSide(!side)}>|||</Text>
        <Text ml={'15px'} cursor={'pointer'} onClick={() => navigate('/')}>ArtKorner</Text>
      </Box>}

    <Box w={['90%', '80%', '50%']} m={'1.5cm auto 1cm auto'}>

      <Heading textAlign={'center'} m={'1cm auto'}>Media Downloader</Heading>
      <Box>
        <Input style={{ border: '1px solid grey', width: '100%', height: '50px', padding: '10px', borderRadius: '25px', textAlign: 'center' }} type="text" placeholder="Enter Photo URL" value={mediaUrl} onChange={(e) => setMediaUrl(e.target.value)} />
        <Button display={'block'} m={'15px auto'} w={'50%'} borderRadius={'25px'} bg={'#FACF0FC7'} onClick={handleDownload}>Download</Button>
      </Box>
      {pre && <Box w={['80%']} m={'auto'}>
        <Image w={'100%'} src={pre && pre} alt='image Data' />
      </Box>}
    </Box>
    </Box>
  )
}
